
/**
 * @sveltech/routify 1.4.9
 * File generated Wed Apr 15 2020 17:10:42 GMT-0700 (Pacific Daylight Time)
 */

//buildRoutes
import { buildRoutes } from "C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/node_modules/@sveltech/routify/runtime/buildRoutes"

//imports
import __layout from 'C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/src/pages/_layout.svelte'
import __fallback from 'C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/src/pages/_fallback.svelte'
import _resume from 'C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/src/pages/resume.svelte'
import _index from 'C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/src/pages/index.svelte'

//keys
const keys = ["isFallback","isIndex","hasParam","path","component","layouts","meta","shortPath"]

//layouts
const layouts = {
  "/_layout": {
    "component": () => __layout,
    "meta": {},
    "relativeDir": "",
    "path": ""
  }
}


//raw routes
const _routes = [
  {
    "component": () => __fallback,
    "meta": {},
    "isIndex": false,
    "isFallback": true,
    "hasParam": false,
    "path": "/_fallback",
    "shortPath": "",
    "layouts": [
      layouts['/_layout']
    ]
  },
  {
    "component": () => _resume,
    "meta": {},
    "isIndex": false,
    "isFallback": false,
    "hasParam": false,
    "path": "/resume",
    "shortPath": "/resume",
    "layouts": [
      layouts['/_layout']
    ]
  },
  {
    "component": () => _index,
    "meta": {},
    "isIndex": true,
    "isFallback": false,
    "hasParam": false,
    "path": "/index",
    "shortPath": "",
    "layouts": [
      layouts['/_layout']
    ]
  }
]

//options
export const options = {"unknownPropWarnings":true}

//routes
export const routes = buildRoutes(_routes, keys)
